var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("center"),_c('i',{staticClass:"rs-icon-close",on:{"click":_vm.handleClose}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }